import { render, staticRenderFns } from "./LiteracyAssessment.vue?vue&type=template&id=48acdbd5&scoped=true&"
import script from "./LiteracyAssessment.vue?vue&type=script&lang=js&"
export * from "./LiteracyAssessment.vue?vue&type=script&lang=js&"
import style0 from "./LiteracyAssessment.vue?vue&type=style&index=0&id=48acdbd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48acdbd5",
  null
  
)

export default component.exports